<template>
	<div class="discovery-end-card" :style="{ '--bg-url': backgroundUrl }">
		<div class="discovery-end-card__logo">
			<ProviderIcon providerShortName="jwt" :lazy="false" size="icon" />
		</div>
		<div class="discovery-end-card__title">These were our recommendations for you!</div>
		<div class="discovery-end-card__text">Didn't find something to watch yet?</div>

		<div class="discovery-end-card__button-row">
			<RouterLink :to="popularLink">
				<BasicButton class="discovery-end-card__button" @click="trackButtonClick">
					Explore the full library
				</BasicButton>
			</RouterLink>
		</div>
	</div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

import { CollectionType } from '@/enums/collection-type';
import { calculateUrl } from '@/helpers/state-helper';
import { TrackingHelper } from '@/helpers/tracking/tracking-helper';

import BasicButton from '@/ui-components/BasicButton.vue';
import ProviderIcon from '@/components/picture/ProviderIcon.vue';

import { useConstantStore } from '@/stores/pinia/useConstantStore';

const router = useRouter();

const constantStore = useConstantStore();

const backgroundUrl = `url(/${ASSETS_DIR}/img/home/bg-tiles/bg-tiles.png)`;

const popularLink = computed(() => {
	return calculateUrl(
		router,
		undefined,
		CollectionType.POPULAR,
		{
			providers: ['jwt'],
		},
		constantStore.providersByShortName
	);
});

function trackButtonClick() {
	TrackingHelper.trackEvent('userinteraction', {
		action: 'click',
		property: 'jwtv-end-card',
		label: 'popular-button',
	});
}
</script>

<style scoped lang="scss">
@import '@/styles/variables.scss';
@import '@/styles/sports.scss';

.discovery-end-card {
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	background: linear-gradient(to bottom, $jw-color-darkblue--dark 10%, transparent 100%), var(--bg-url);
	background-size: cover;
	background-position: top;
	margin-block-start: 24px;
	margin-inline: -$app-x-margin;
	padding: 20px;

	@media (max-width: $breakpoint-two-rows) {
		margin-inline: -15px;
	}

	&__logo {
		margin-block-end: 40px;
		:deep(.picture-element .provider-icon) {
			height: 80px !important;
			min-width: 80px !important;
		}
	}

	&__text {
		font-size: 22px;
		line-height: 28px;
		color: $color-neutral-neutral-light;
		margin-block-end: 40px;
		text-align: center;

		@media (max-width: calc($screen-sm-min - 1px)) {
			font-size: 16px;
			line-height: 22px;
		}
	}

	&__title {
		font-weight: 900;
		font-size: 40px;
		line-height: 48px;
		color: $jw-color-white;
		margin-block-end: 16px;
		text-align: center;

		@media (max-width: calc($screen-sm-min - 1px)) {
			font-size: 28px;
			line-height: 32px;
		}
	}

	&__button-row {
		display: flex;
		justify-content: space-between;

		& > a:not(:first-of-type) {
			margin-inline-start: 16px;
		}

		@media (max-width: calc($screen-sm-min - 1px)) {
			flex-direction: column;
			align-items: center;

			& > a:not(:first-of-type) {
				margin: 16px 0 0;
			}
		}
	}

	&__button:not(:first-of-type) {
		margin-inline-start: 16px;

		@media (max-width: calc($screen-sm-min - 1px)) {
			margin: 16px 0 0;
		}
	}
}
</style>
